export enum EmulationProjectMode {
	Basic =  'basic',
	Advanced = 'advanced',
}